/*
 * Detact Mobile Browser
 */

import { axios, axiosAPIClient } from '../../front/src/utils/axios';
import { getProductFractionSpecificationString } from '../../front/src/utils/getProductFractionSpecificationString';
import { sanitizeString } from '../../front/src/utils/sanitizeString';

if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent)) {
  $('html').addClass('ismobile');
}

// global init for ctp files and javascrits
window.axios = axios;
window.axiosAPIClient = axiosAPIClient;

$(window).load(() => {
  /* --------------------------------------------------------
   Page Loader
   -----------------------------------------------------------*/
  if (!$('html').hasClass('ismobile') && $('.page-loader')[0]) {
    setTimeout(() => {
      $('.page-loader').fadeOut();
    }, 500);
  }
});

$(document).ready(() => {
  window.pleaseWait = (text) => {
    swal({
      title: i18n('Please.wait...'),
      imageUrl: '/img/reload.gif',
      showConfirmButton: false,
      text,
    });
  };

  window.swalAsync = params => new Promise(resolve => swal(params, resolve));

  /**
   * Formats string
   * @deprecated
   * @param source {string} format string
   * @param params {string[]|Object} parameter to inject
   * @return {string}
   */
  window.strFormat = (source, params) => {
    params.forEach((n, i) => {
      source = source.replaceAll(new RegExp(`\\{${i}\\}`, 'g'), n);
    });
    return source;
  };

  window.itemCompleted = item => item.type === 1 && [50, 90].includes(item.status)
    || [2, 4].includes(item.type) && [60, 90].includes(item.status);

  window.sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

  window.validateEmail = (text) => {
    const regex = /^[\w.!#$%&’*+/=?^`{|}~-]+@[a-zA-Z\d-]+(?:\.[a-zA-Z\d-]+)*$/;
    return new RegExp(regex).test(text);
  };

  function isFilePDF(src) {
    src = src.toLowerCase();
    return src.includes('application/pdf') || (src.includes('.') && src.split('.')[src.split('.').length - 1] === 'pdf');
  }

  window.isIE = () => ((navigator.userAgent.includes('MSIE')) || (!!document.documentMode == true));

  window.downloadPhotoIE = (url) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.addEventListener('load', function(e) {
      if (this.status == 200) {
        const data = this.response;
        window.navigator.msSaveOrOpenBlob(data, url.split('/')[url.split('/').length - 1]);
      }
    });

    xhr.send(null);
  };

  window.forceDownload = (url) => {
    const splits = url.split('/');
    const filename = splits.at(-1).split('?')[0];

    const config = { responseType: 'blob' };
    axios.get(`${url}?${Date.now()}`, config).then((response) => {
      const blob = new Blob([response.data], { type: 'application/octet-stream' });
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.append(elem);
        elem.click();
        elem.remove();
      }
    }).catch((error) => {
      swal({
        type: 'error',
        title: i18n('Error.occured'),
        text: error.response ? error.response.statusText : i18n('Error.occured'),
      });
    });
  };

  window.photoDialogGenerateButton = (zmdiIcon, title, onclick) => {
    const icon = document.createElement('i');
    icon.classList.add('zmdi');
    icon.classList.add('zmdi-hc-1-8');
    icon.classList.add(zmdiIcon);
    icon.classList.add('center-download-icon');
    icon.classList.add('delete-in-image-position');
    icon.style.zIndex = 'auto';

    const button = document.createElement('a');
    button.addEventListener('click', onclick);
    button.style.cursor = 'pointer';
    button.title = title;
    button.classList.add('delete-image-icon');
    button.classList.add('download-in-image');
    button.append(icon);
    return button;
  };

  window.photoDialogGenerateButtonRow = (file, div, holderClass) => {
    const buttonHolder = document.createElement('div');
    buttonHolder.classList.add(holderClass);

    if (file.deletable) {
      buttonHolder.append(photoDialogGenerateButton(
        'zmdi-delete',
        i18n('Delete'),
        file.onClickCB
      ));
    }

    if (file.downloadable) {
      buttonHolder.append(photoDialogGenerateButton(
        'zmdi-download',
        i18n('Download'),
        () => forceDownload(file.src)
      ));
      div.dataset.src = file.src;
    }

    div.append(buttonHolder);
  };

  window.addPhotoToOutput = (targetDiv, cssClass, file, showPdfModalId = 'showFileModal', lightboxCollectionName = null) => {
    //  file - id, thumbnail, src, title, onClickCB, deletable, downloadable, description, pdfClass, pdfInnerDescription
    const div = document.createElement('div');
    div.setAttribute('class', `${cssClass} add-file-thumbnail-container`);
    div.setAttribute('id', file.id);

    if (file.type === 'application/pdf' || isFilePDF(file.src)) {
      const pdfDiv = document.createElement('div');
      pdfDiv.setAttribute('class', file.pdfClass ? file.pdfClass : 'pdf-photo-thumbnail');

      photoDialogGenerateButtonRow(file, div, 'download-in-pdf-container');
      const imgWorkaround = document.createElement('img');
      imgWorkaround.style.display = 'none';
      imgWorkaround.classList.add(file.thumbnail);
      div.append(imgWorkaround); // Workaround for adding photos - class must be set on img Element!

      const svgIcon = document.createElement('svg');
      const svgIconTitle = document.createElement('title');
      svgIconTitle.append(document.createTextNode(sanitizeString(file.title)));
      svgIcon.append(svgIconTitle);
      const svgIconPath = document.createElement('path');
      svgIconPath.setAttribute('d', 'M21 13v-3l-6-7h-10.997c-1.106 0-2.003 0.898-2.003 2.007v22.985c0 1.109 0.891 2.007 1.997 2.007h15.005c1.103 0 1.997-0.898 1.997-1.991v-2.009h7.993c1.661 0 3.007-1.342 3.007-2.999v-7.002c0-1.656-1.336-2.999-3.007-2.999h-7.993zM20 26v2.007c0 0.548-0.448 0.993-1 0.993h-15c-0.545 0-1-0.446-1-0.995v-23.009c0-0.54 0.446-0.995 0.996-0.995h10.004v4.994c0 1.119 0.895 2.006 1.998 2.006h4.002v2h-7.993c-1.661 0-3.007 1.342-3.007 2.999v7.002c0 1.656 1.336 2.999 3.007 2.999h7.993zM15 4.5l4.7 5.5h-3.703c-0.546 0-0.997-0.452-0.997-1.009v-4.491zM11.995 14h17.011c1.092 0 1.995 0.892 1.995 1.992v7.016c0 1.092-0.893 1.992-1.995 1.992h-17.011c-1.092 0-1.995-0.892-1.995-1.992v-7.016c0-1.092 0.893-1.992 1.995-1.992zM25 19v-2h4v-1h-5v7h1v-3h3v-1h-3zM12 18v-2h2.995c1.111 0 2.005 0.895 2.005 2 0 1.112-0.898 2-2.005 2h-1.995v3h-1v-5zM13 17v2h2.001c0.552 0 0.999-0.444 0.999-1 0-0.552-0.443-1-0.999-1h-2.001zM18 16h2.995c1.111 0 2.005 0.898 2.005 2.006v2.988c0 1.119-0.898 2.006-2.005 2.006h-2.995v-7zM19 17v5h2.001c0.552 0 0.999-0.444 0.999-1v-3c0-0.552-0.443-1-0.999-1h-2.001z');
      svgIcon.append(svgIconPath);
      pdfDiv.append(svgIcon);

      if (file.pdfInnerDescription) {
        pdfDiv.append(document.createTextNode(sanitizeString(file.pdfInnerDescription)));
      }

      $(pdfDiv).click(() => {
        // replaces the embed element with a clone of it self,
        // because just changing src attribute of embed does not change content
        const modalSrc = $(`#${showPdfModalId}Src`);
        const modal = $(`#${showPdfModalId}`);
        const modalTitle = $(`#${showPdfModalId}Title`);
        modalSrc.replaceWith(
          modalSrc
            .clone()
            .attr('id', `${showPdfModalId}Src`)
            .attr('src', file.src)
            .attr('type', 'application/pdf')
            .removeClass('center')
            .addClass('center-pdf')
        );
        modal.attr('src', file.src);
        modalTitle.text(sanitizeString(file.title));
        modal.modal('show');
      });
      $(div).append(pdfDiv);
    } else {
      photoDialogGenerateButtonRow(file, div, 'download-in-image-container');

      const lightboxHref = document.createElement('a');
      lightboxHref.href = file.src;
      lightboxHref.dataset.lightbox = lightboxCollectionName || targetDiv.id || 'lightbox';
      lightboxHref.dataset.title = file.description || file.title || '';

      const lightboxImg = document.createElement('img');
      lightboxImg.classList.add(file.thumbnail);
      lightboxImg.src = file.src;
      lightboxImg.title = file.title;

      lightboxHref.append(lightboxImg);
      div.append(lightboxHref);
    }

    if (file.description) {
      $(div).append(file.description);
    }

    targetDiv.insertBefore(div, null);
  };

  window.newGuid = () => {
    const crypto = window.crypto || window.msCrypto;
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replaceAll(/[018]/g, c =>

      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  };

  window.deletePhotoFromServer = photoUuid => axiosAPIClient.delete(`/itemPhotos/${photoUuid}`);

  window.getPhotosFromItemUuid = (itemUuid, category) => {
    const parameter = (category === null ? '' : (`?category=${category}`));
    return axiosAPIClient.get(`/items/${itemUuid}/itemPhotos${parameter}`);
  };

  window.appendDataToSelect = (select, options, clear) => {
    if (clear) {
      select.empty();
    }

    if (!Array.isArray(options)) {
      options = [options];
    }

    options.forEach((option) => {
      const newOption = $('<option>').val(option.value).append($('<span>').text(option.text));
      if (option.additionalData) {
        newOption.append($('<small class="text-muted">')
          .text(option.additionalData));
      }

      if (option.norm_code || option.article_number) {
        const productFractionSpecificationString = getProductFractionSpecificationString(option);
        newOption.append($('<small class="text-muted">')
          .text(` ${productFractionSpecificationString}`));
      }

      if (Object.keys(option).contains(key => key.startsWith('data-'))) {
        Object.keys(option).filter(key => key.startsWith('data-')).forEach(
          (key) => {
            newOption.data(key.replace('data-', ''), option[key]);
          }
        );
      }

      if (option.selected) {
        newOption.attr('selected', true);
      }

      select.append(newOption);
    });
    select.selectpicker('refresh');
  };

  /* --------------------------------------------------------
      Layout
  -----------------------------------------------------------*/
  (function() {
    // Get saved layout type from LocalStorage
    const layoutStatus = localStorage.getItem('ma-layout-status');

    if (!$('#header-2')[0] // Make it work only on normal headers
      && layoutStatus == 1) {
      $('body').addClass('sw-toggled');
      $('#tw-switch').prop('checked', true);
    }

    $('body').on('change', '#toggle-width input:checkbox', function() {
      if ($(this).is(':checked')) {
        setTimeout(() => {
          $('body').addClass('toggled sw-toggled');
          localStorage.setItem('ma-layout-status', 1);
        }, 250);
      } else {
        setTimeout(() => {
          $('body').removeClass('toggled sw-toggled');
          localStorage.setItem('ma-layout-status', 0);
        }, 250);
      }
    });
  })();

  /* --------------------------------------------------------
      Scrollbar
  -----------------------------------------------------------*/
  function scrollBar(selector, theme, mousewheelaxis) {
    $(selector).mCustomScrollbar({
      theme,
      scrollInertia: 100,
      axis: 'yx',
      mouseWheel: {
        enable: true,
        axis: mousewheelaxis,
        preventDefault: true,
      },
    });
  }

  if (!$('html').hasClass('ismobile') // On Custom Class
    && $('.c-overflow')[0]) {
    scrollBar('.c-overflow', 'minimal-dark', 'y');
  }

  /*
   * Top Search
   */
  (function() {
    $('body').on('click', '#top-search > a', (e) => {
      e.preventDefault();

      $('#header').addClass('search-toggled');
      $('#top-search-wrap input').focus();
    });

    $('body').on('click', '#top-search-close', (e) => {
      e.preventDefault();

      $('#header').removeClass('search-toggled');
    });
  })();

  /*
   * Sidebar
   */
  (function() {
    // Toggle
    $('body').on('click', '#menu-trigger, #chat-trigger', function(e) {
      let $elem = null; let
        $elem2 = null;
      e.preventDefault();
      const x = $(this).data('trigger');

      $(x).toggleClass('toggled');
      $(this).toggleClass('open');

      // Close opened sub-menus
      $('.sub-menu.toggled').not('.active').each(function() {
        $(this).removeClass('toggled');
        $(this).find('ul').hide();
      });


      $('.profile-menu .main-menu').hide();

      if (x == '#sidebar') {
        $elem = '#sidebar';
        $elem2 = '#menu-trigger';
        $('#chat-trigger').removeClass('open');

        if ($('#chat').hasClass('toggled')) {
          $('#chat').removeClass('toggled');
        } else {
          $('#header').toggleClass('sidebar-toggled');
        }
      }

      if (x == '#chat') {
        $elem = '#chat';
        $elem2 = '#chat-trigger';

        $('#menu-trigger').removeClass('open');

        if ($('#sidebar').hasClass('toggled')) {
          $('#sidebar').removeClass('toggled');
        } else {
          $('#header').toggleClass('sidebar-toggled');
        }
      }

      // When clicking outside
      if ($('#header').hasClass('sidebar-toggled')) {
        $(document).on('click', (e) => {
          if (($(e.target).closest($elem).length === 0) && ($(e.target).closest($elem2).length === 0)) {
            setTimeout(() => {
              $($elem).removeClass('toggled');
              $('#header').removeClass('sidebar-toggled');
              $($elem2).removeClass('open');
            });
          }
        });
      }
    });

    // Submenu
    $('body').on('click', '.sub-menu > a', function(e) {
      e.preventDefault();
      $(this).next().slideToggle(200);
      $(this).parent().toggleClass('toggled');
    });
  })();

  /*
   * Clear Notification
   */
  $('body').on('click', '[data-clear="notification"]', function(e) {
    e.preventDefault();

    const x = $(this).closest('.listview');
    const y = x.find('.lv-item');
    const z = y.size();

    $(this).parent().fadeOut();

    x.find('.list-group').prepend('<i class="grid-loading hide-it"></i>');
    x.find('.grid-loading').fadeIn(1500);


    let w = 0;
    y.each(function() {
      const z = $(this);
      setTimeout(() => {
        z.addClass('animated fadeOutRightBig').delay(1000).queue(() => {
          z.remove();
        });
      }, w += 150);
    });

    // Popup empty message
    setTimeout(() => {
      $('#notifications').addClass('empty');
    }, (z * 150) + 200);
  });

  /*
   * Dropdown Menu
   */
  if ($('.dropdown')[0]) {
    // Propagate
    $('body').on('click', '.dropdown.open .dropdown-menu', (e) => {
      e.stopPropagation();
    });

    $('.dropdown').on('shown.bs.dropdown', function(e) {
      if ($(this).attr('data-animation')) {
        $animArray = [];
        $animation = $(this).data('animation');
        $animArray = $animation.split(',');
        $animationIn = `animated ${$animArray[0]}`;
        $animationOut = `animated ${$animArray[1]}`;
        $animationDuration = '';
        if ($animArray[2]) {
          $animationDuration = $animArray[2];
        } else {
          $animationDuration = 500; // if duration is not defined, default is set to 500ms
        }

        $(this).find('.dropdown-menu').removeClass($animationOut);
        $(this).find('.dropdown-menu').addClass($animationIn);
      }
    });

    $('.dropdown').on('hide.bs.dropdown', function(e) {
      if ($(this).attr('data-animation')) {
        e.preventDefault();
        $this = $(this);
        $dropdownMenu = $this.find('.dropdown-menu');

        $dropdownMenu.addClass($animationOut);
        setTimeout(() => {
          $this.removeClass('open');
        }, $animationDuration);
      }
    });
  }

  /*
   * Calendar Widget
   */
  if ($('#calendar-widget')[0]) {
    (function() {
      $('#calendar-widget').fullCalendar({
        contentHeight: 'auto',
        theme: true,
        header: {
          right: '',
          center: 'prev, title, next',
          left: '',
        },
        defaultDate: '2014-06-12',
        editable: true,
        events: [
          {
            title: 'All Day',
            start: '2014-06-01',
            className: 'bgm-cyan',
          }, {
            title: 'Long Event',
            start: '2014-06-07',
            end: '2014-06-10',
            className: 'bgm-orange',
          }, {
            id: 999,
            title: 'Repeat',
            start: '2014-06-09',
            className: 'bgm-lightgreen',
          }, {
            id: 999,
            title: 'Repeat',
            start: '2014-06-16',
            className: 'bgm-lightblue',
          }, {
            title: 'Meet',
            start: '2014-06-12',
            end: '2014-06-12',
            className: 'bgm-green',
          }, {
            title: 'Lunch',
            start: '2014-06-12',
            className: 'bgm-cyan',
          }, {
            title: 'Birthday',
            start: '2014-06-13',
            className: 'bgm-amber',
          }, {
            title: 'Google',
            url: 'http://google.com/',
            start: '2014-06-28',
            className: 'bgm-amber',
          },
        ],
      });
    })();
  }

  /*
   * Weather Widget
   */
  if ($('#weather-widget')[0]) {
    $.simpleWeather({
      location: 'Austin, TX',
      woeid: '',
      unit: 'f',
      success(weather) {
        let html = `<div class="weather-status">${weather.temp}&deg;${weather.units.temp}</div>`;
        html += `<ul class="weather-info"><li>${weather.city}, ${weather.region}</li>`;
        html += `<li class="currently">${weather.currently}</li></ul>`;
        html += `<div class="weather-icon wi-${weather.code}"></div>`;
        html += '<div class="dash-widget-footer"><div class="weather-list tomorrow">';
        html += `<span class="weather-list-icon wi-${weather.forecast[2].code}"></span><span>${weather.forecast[1].high}/${weather.forecast[1].low}</span><span>${weather.forecast[1].text}</span>`;
        html += '</div>';
        html += '<div class="weather-list after-tomorrow">';
        html += `<span class="weather-list-icon wi-${weather.forecast[2].code}"></span><span>${weather.forecast[2].high}/${weather.forecast[2].low}</span><span>${weather.forecast[2].text}</span>`;
        html += '</div></div>';
        $('#weather-widget').html(html);
      },
      error(error) {
        $('#weather-widget').html(`<p>${error}</p>`);
      },
    });
  }

  /*
   * Todo Add new item
   */
  if ($('#todo-lists')[0]) {
    // Add Todo Item
    $('body').on('click', '#add-tl-item .add-new-item', function() {
      $(this).parent().addClass('toggled');
    });

    // Dismiss
    $('body').on('click', '.add-tl-actions > a', function(e) {
      e.preventDefault();
      const x = $(this).closest('#add-tl-item');
      const y = $(this).data('tl-action');

      if (y == 'dismiss') {
        x.find('textarea').val('');
        x.removeClass('toggled');
      }

      if (y == 'save') {
        x.find('textarea').val('');
        x.removeClass('toggled');
      }
    });
  }

  /*
   * Auto Hight Textarea
   */
  if ($('.auto-size')[0]) {
    autosize($('.auto-size'));
  }

  /*
   * Profile Menu
   */
  $('body').on('click', '.profile-menu > a', function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('toggled');
    $(this).next().slideToggle(200);
  });

  /*
   * Text Feild
   */

  // Add blue animated border and remove with condition when focus and blur
  if ($('.fg-line')[0]) {
    $('body').on('focus', '.fg-line .form-control', function() {
      $(this).closest('.fg-line').addClass('fg-toggled');
    });

    $('body').on('blur', '.form-control', function() {
      const p = $(this).closest('.form-group, .input-group');
      const i = p.find('.form-control').val();

      if (p.hasClass('fg-float')) {
        if (i.length == 0) {
          $(this).closest('.fg-line').removeClass('fg-toggled');
        }
      } else {
        $(this).closest('.fg-line').removeClass('fg-toggled');
      }
    });
  }

  // Add blue border for pre-valued fg-flot text feilds
  if ($('.fg-float')[0]) {
    $('.fg-float .form-control').each(function() {
      const i = $(this).val();

      if (!i.length == 0) {
        $(this).closest('.fg-line').addClass('fg-toggled');
      }
    });
  }

  /*
   * Audio and Video
   */
  if ($('audio, video')[0]) {
    $('video,audio').mediaelementplayer();
  }

  /*
   * Tag Select
   */
  if ($('.chosen')[0]) {
    $('.chosen').chosen({
      width: '100%',
      allow_single_deselect: true,
    });
  }

  /*
   * Input Slider
   */
  // Basic
  if ($('.input-slider')[0]) {
    $('.input-slider').each(function() {
      const isStart = $(this).data('is-start');

      $(this).noUiSlider({
        start: isStart,
        range: {
          min: 0,
          max: 100,
        },
      });
    });
  }

  // Range slider
  if ($('.input-slider-range')[0]) {
    $('.input-slider-range').noUiSlider({
      start: [30, 60],
      range: {
        min: 0,
        max: 100,
      },
      connect: true,
    });
  }

  // Range slider with value
  if ($('.input-slider-values')[0]) {
    $('.input-slider-values').noUiSlider({
      start: [45, 80],
      connect: true,
      direction: 'rtl',
      behaviour: 'tap-drag',
      range: {
        min: 0,
        max: 100,
      },
    });

    $('.input-slider-values').Link('lower').to($('#value-lower'));
    $('.input-slider-values').Link('upper').to($('#value-upper'), 'html');
  }

  /*
   * Input Mask
   */
  if ($('input-mask')[0]) {
    $('.input-mask').mask();
  }

  /*
   * Color Picker
   */
  if ($('.color-picker')[0]) {
    $('.color-picker').each(function() {
      const colorOutput = $(this).closest('.cp-container').find('.cp-value');
      $(this).farbtastic(colorOutput);
    });
  }

  /*
   * HTML Editor
   */
  if ($('.html-editor')[0]) {
    $('.html-editor').summernote({ height: 150 });
  }

  if ($('.html-editor-click')[0]) {
    // Edit
    $('body').on('click', '.hec-button', () => {
      $('.html-editor-click').summernote({ focus: true });
      $('.hec-save').show();
    });

    // Save
    $('body').on('click', '.hec-save', () => {
      $('.html-editor-click').code();
      $('.html-editor-click').destroy();
      $('.hec-save').hide();
      notify('Content Saved Successfully!', 'success');
    });
  }

  // Air Mode
  if ($('.html-editor-airmod')[0]) {
    $('.html-editor-airmod').summernote({ airMode: true });
  }

  /*
   * Date Time Picker
   */

  // Date Time Picker
  if ($('.date-time-picker')[0]) {
    $('.date-time-picker').datetimepicker();
  }

  // Time
  if ($('.time-picker')[0]) {
    $('.time-picker').datetimepicker({ format: 'HH:mm' });
  }

  // Date
  if ($('.date-picker')[0]) {
    $('.date-picker').datetimepicker({
      // enabledDates: [
      //   new Date(),
      //   new Date(new Date().getTime() + 60 * 60 * 24 * 1000),
      // ],
      daysOfWeekDisabled: [0, 6],
      format: 'YYYY-MM-DD',
      locale: lang || 'de',
    });
  }

  /*
   * Form Wizard
   */

  if ($('.form-wizard-basic')[0]) {
    $('.form-wizard-basic').bootstrapWizard({
      tabClass: 'fw-nav',
      nextSelector: '.next',
      previousSelector: '.previous',
    });
  }

  /*
   * Bootstrap Growl - Notifications popups
   */
  function notify(message, type) {
    $.growl({ message }, {
      type,
      allow_dismiss: false,
      label: 'Cancel',
      className: 'btn-xs btn-inverse',
      placement: {
        from: 'top',
        align: 'right',
      },
      delay: 2500,
      animate: {
        enter: 'animated bounceIn',
        exit: 'animated bounceOut',
      },
      offset: {
        x: 20,
        y: 85,
      },
    });
  }

  /*
   * Waves Animation
   */
  (function() {
    Waves.attach('.btn:not(.btn-icon):not(.btn-float)');
    Waves.attach('.btn-icon, .btn-float', ['waves-circle', 'waves-float']);
    Waves.init();
  })();

  /*
   * Lightbox
   */
  lightbox.option({
    resizeDuration: 200,
    wrapAround: true,
    showImageNumberLabel: true,
    albumLabel: i18n('Picture.index.of.count'),
  });

  /*
   * Link prevent
   */
  $('body').on('click', '.a-prevent', (e) => {
    e.preventDefault();
  });

  /*
   * Collaspe Fix
   */
  if ($('.collapse')[0]) {
    // Add active class for opened items
    $('.collapse').on('show.bs.collapse', function(e) {
      $(this).closest('.panel').find('.panel-heading').addClass('active');
    });

    $('.collapse').on('hide.bs.collapse', function(e) {
      $(this).closest('.panel').find('.panel-heading').removeClass('active');
    });

    // Add active class for pre opened items
    $('.collapse.in').each(function() {
      $(this).closest('.panel').find('.panel-heading').addClass('active');
    });
  }

  /*
   * Tooltips
   */
  if ($('[data-toggle="tooltip"]')[0]) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  /*
   * Popover
   */
  if ($('[data-toggle="popover"]')[0]) {
    $('[data-toggle="popover"]').popover();
  }

  /*
   * Message
   */

  // Actions
  if ($('.on-select')[0]) {
    const checkboxes = '.lv-avatar-content input:checkbox';
    const actions = $('.on-select').closest('.lv-actions');

    $('body').on('click', checkboxes, () => {
      if ($(`${checkboxes}:checked`)[0]) {
        actions.addClass('toggled');
      } else {
        actions.removeClass('toggled');
      }
    });
  }

  if ($('#ms-menu-trigger')[0]) {
    $('body').on('click', '#ms-menu-trigger', function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $('.ms-menu').toggleClass('toggled');
    });
  }

  /*
   * Fullscreen Browsing
   */
  if ($('[data-action="fullscreen"]')[0]) {
    const fs = $('[data-action=\'fullscreen\']');
    fs.on('click', (e) => {
      e.preventDefault();

      // Launch
      function launchIntoFullscreen(element) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }

      // Exit
      function exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }

      launchIntoFullscreen(document.documentElement);
      fs.closest('.dropdown').removeClass('open');
    });
  }

  /*
   * Clear Local Storage
   */
  if ($('[data-action="clear-localstorage"]')[0]) {
    const cls = $('[data-action="clear-localstorage"]');

    cls.on('click', (e) => {
      e.preventDefault();

      swal({
        title: 'Are you sure?',
        text: 'All your saved localStorage values will be removed',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes, delete it!',
        closeOnConfirm: false,
      }, () => {
        localStorage.clear();
        swal('Done!', 'localStorage is cleared', 'success');
      });
    });
  }

  /*
   * Profile Edit Toggle
   */
  if ($('[data-pmb-action]')[0]) {
    $('body').on('click', '[data-pmb-action]', function(e) {
      e.preventDefault();
      const d = $(this).data('pmb-action');

      if (d === 'edit') {
        $(this).closest('.pmb-block').toggleClass('toggled');
      }

      if (d === 'reset') {
        $(this).closest('.pmb-block').removeClass('toggled');
      }
    });
  }

  /*
   * IE 9 Placeholder
   */
  if ($('html').hasClass('ie9')) {
    $('input, textarea').placeholder({ customClass: 'ie9-placeholder' });
  }


  /*
   * Listview Search
   */
  if ($('.lvh-search-trigger')[0]) {
    $('body').on('click', '.lvh-search-trigger', function(e) {
      e.preventDefault();
      x = $(this).closest('.lv-header-alt').find('.lvh-search');

      x.fadeIn(300);
      x.find('.lvhs-input').focus();
    });

    // Close Search
    $('body').on('click', '.lvh-search-close', () => {
      x.fadeOut(300);
      setTimeout(() => {
        x.find('.lvhs-input').val('');
      }, 350);
    });
  }


  /*
   * Print
   */
  if ($('[data-action="print"]')[0]) {
    $('body').on('click', '[data-action="print"]', (e) => {
      e.preventDefault();

      window.print();
    });
  }

  /*
   * Typeahead Auto Complete
   */
  if ($('.typeahead')[0]) {
    const statesArray = [
      'Alabama',
      'Alaska',
      'Arizona',
      'Arkansas',
      'California',
      'Colorado',
      'Connecticut',
      'Delaware',
      'Florida',
      'Georgia',
      'Hawaii',
      'Idaho',
      'Illinois',
      'Indiana',
      'Iowa',
      'Kansas',
      'Kentucky',
      'Louisiana',
      'Maine',
      'Maryland',
      'Massachusetts',
      'Michigan',
      'Minnesota',
      'Mississippi',
      'Missouri',
      'Montana',
      'Nebraska',
      'Nevada',
      'New Hampshire',
      'New Jersey',
      'New Mexico',
      'New York',
      'North Carolina',
      'North Dakota',
      'Ohio',
      'Oklahoma',
      'Oregon',
      'Pennsylvania',
      'Rhode Island',
      'South Carolina',
      'South Dakota',
      'Tennessee',
      'Texas',
      'Utah',
      'Vermont',
      'Virginia',
      'Washington',
      'West Virginia',
      'Wisconsin',
      'Wyoming',
    ];
    const states = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.whitespace,
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      local: statesArray,
    });

    $('.typeahead').typeahead({
      hint: true,
      highlight: true,
      minLength: 1,
    }, {
      name: 'states',
      source: states,
    });
  }


  /*
   * Wall
   */
  if ($('.wcc-toggle')[0]) {
    const z = '<div class="wcc-inner">'
      + '<textarea class="wcci-text auto-size" placeholder="Write Something..."></textarea>'
      + '</div>'
      + '<div class="m-t-15">'
      + '<button class="btn btn-sm btn-primary">Post</button>'
      + '<button class="btn btn-sm btn-link wcc-cencel">Cancel</button>'
      + '</div>';


    $('body').on('click', '.wcc-toggle', function() {
      $(this).parent().html(z);
      autosize($('.auto-size')); // Reload Auto size textarea
    });

    // Cancel
    $('body').on('click', '.wcc-cencel', function(e) {
      e.preventDefault();

      $(this).closest('.wc-comment').find('.wcc-inner').addClass('wcc-toggle')
        .html('Write Something...');
    });
  }

  /*
   * Skin Change
   */
  $('body').on('click', '[data-skin]', function() {
    const skin = $(this).data('skin');

    $('[data-current-skin]').attr('data-current-skin', skin);
  });

  /*
   * Remove number input scroll functionality
   */
  $(document).on('wheel', 'input[type=number]', function() {
    $(this).blur();
  });
});
